export function isArrayOfT<T>(value: string[] | T[]): value is T[] {
  const values: (string | T)[] = value
  return !values.every((item: string | T) => typeof item === 'string')
}
